import React, { useEffect, useState } from "react";
import { Card, Typography, Button, Row, Col } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { URL } from "../../helper/Mainurl";
import { apiClient } from "../../utils/apiClient";

const { Title, Paragraph } = Typography;

const NotesCard = styled(Card)`
  border-radius: 16px;
  background-color: #defdec;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 280px;
  position: relative;
  padding: 16px;
  overflow: hidden;

  .ant-card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 0;
  }

  @media (max-width: 768px) {
    min-height: auto;
  }
`;

const NoteTitle = styled(Title)`
  && {
    font-weight: 600;
    font-size: 16px;
    color: #1d2433;
    margin-bottom: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* Limit to 2 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }
`;

const NoteContent = styled(Paragraph)`
  && {
    color: #6b7280;
    font-size: 14px;
    margin-bottom: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 4; /* Limit to 4 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    flex-grow: 1;
  }
`;

const NoteFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
`;

const RecentNotesSection = () => {
  const navigate = useNavigate();
  const [notes, setNotes] = useState([]);

  const bgColors = ["#ECFDF5", "#EFF6FF", "#FFFBEB"];

  const fetchNotes = async () => {
    try {
      const response = await apiClient.get(
        `${URL}/v1/note/list/1?dashboard=true`
      );
      const fetchedNotes = response.data?.data?.notes || [];

      const formattedNotes = fetchedNotes.map((note, index) => ({
        id: note.id,
        title:
          note.title?.length > 70
            ? note.title.substring(0, 70) + "…"
            : note.title,
        content: note.description,
        date: note.created_at,
        bgColor: bgColors[index % bgColors.length],
      }));

      setNotes(formattedNotes);
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchNotes();
  }, []);

  const handleViewAll = () => {
    navigate("/notes");
  };

  return (
    <div
      style={{ backgroundColor: "#ffffff", borderRadius: "8px", padding: 20 }}
    >
      <Row gutter={[16, 16]}>
        {notes && notes.length ? (
          notes.map((note) => (
            <Col
              className="notes-dashboard"
              xs={24}
              sm={12}
              lg={12}
              xl={6}
              key={note.id}
            >
              <NotesCard className="dashboard-notes-card" hoverable>
                <div className="card-content-notes">
                  <NoteTitle level={4}>{note.title}</NoteTitle>
                  <NoteContent>{note.content}</NoteContent>
                </div>
                <NoteFooter>
                  <small style={{ color: "#767a83", fontSize: 12 }}>
                    {note.date}
                  </small>
                  {/* <Button
                    className="notesCardDelete"
                    type="text"
                    icon={<DeleteOutlined />}
                    onClick={(e) => {
                      e.stopPropagation();
                      // delete handler here
                    }}
                    style={{
                      color: "#fff",
                      backgroundColor: "#55D8C1",
                      borderRadius: "50%",
                    }}
                  /> */}
                </NoteFooter>
              </NotesCard>
            </Col>
          ))
        ) : (
          <h3 style={{ textAlign: "center", width: "100%" }}>No Data Found</h3>
        )}
      </Row>
    </div>
  );
};

export default RecentNotesSection;
